import { Injectable } from '@angular/core';
import { Entity } from '../models/mvp-query-response-dto';
import { Router } from '@angular/router';
import { TabId } from '../enums/tab-id.enum';
import { SearchService } from './search.service';
import { RoutingService } from './routing.service';
import { TAB_ID } from '../constants';
import { map, Observable } from 'rxjs';
import { MultiLangStrDto } from '../models/multi-lang-str-dto';
import { GaService } from './ga.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ArchiveImageGalleryComponent } from '../components/scientific-archive-document/scientific-archive-document-details/archive-image-gallery/archive-image-gallery.component';
import { ImageDto } from '../models/image-dto';
import { ApiService } from './api.service';
import { PdfViewerDialogComponent } from '../components/shared/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class MenuItemsService {
  private lastFocusedElement: any = null;
  menuItems: any[] | undefined;
  languageSpecificMenuItems: any[] | undefined;
  constructor(private router: Router,    private dialogService: DialogService
, private searchService: SearchService, private routingService: RoutingService,private gaService:GaService,     private apiService: ApiService, private languageService: LanguageService
) { }


  setMenuItems(selectedEntity: Entity, showInTableOption: boolean = false, showInTable?: Function) {
    this.menuItems = [
      {
        icon: 'pi pi-fw pi-file',
        label: new MultiLangStrDto('פרטים מלאים', 'Full details'),
        command: () => this.handleClickDetails(selectedEntity),
        disabled: !selectedEntity.linkInfo || selectedEntity.linkInfo?.isNewTab || selectedEntity.entityType === 'orthophoto' || selectedEntity.entityType === 'orthophotos'
      },
      // {
      //   label: new MultiLangStrDto('מקבילות', 'Parallels'),
      //   icon: 'pi pi-fw pi-pencil',
      //   disabled: true
      // },
      {
        label: new MultiLangStrDto('פרסומי רשות העתיקות', 'IAA Publications'),
        icon: 'pi pi-fw pi-user',
        command: () => this.handleClickEntity(selectedEntity, ['publications'])
      },
      // {
      //   label: new MultiLangStrDto('פרסומים אחרים', 'Other Publications'),
      //   icon: 'pi pi-fw pi-calendar',
      //   disabled: true
      // },
      // {
      //   label: new MultiLangStrDto('מידע סטטוטורי', 'Statutory information'),
      //   icon: 'pi pi-fw pi-calendar',
      //   disabled: true
      // },
      {
        label: new MultiLangStrDto('פוטוגרמטריה', 'Photogrammetry'),
        icon: 'pi pi-fw pi-calendar',
        command: () => this.handleClickEntity(selectedEntity, ['photogrammetric_models']),
        disabled: selectedEntity?.entityType == 'photogrammetric_model'
      },
      // {
      //   label: new MultiLangStrDto('תמונות', 'Photos'),
      //   icon: 'pi pi-fw pi-calendar',
      //   disabled: true
      // },
      {
        label: new MultiLangStrDto('הורדת מודל תלת-ממדי', 'Download 3D Model'),
        icon: 'pi pi-fw pi-download',
        command: () => this.downloadModel(selectedEntity),
        disabled: selectedEntity.entityType !== 'photogrammetric_model'
      },
    ];
    // Conditionally add the "הצג בטבלה" option if showInTableOption is true
    if (showInTableOption) {
      this.menuItems.unshift({
        icon: 'pi pi-table ng-star-inserted',
        label: new MultiLangStrDto('הצג בטבלה', 'Show in table'),
        command: () => showInTable?.(selectedEntity),
        disabled: false
      });
    } else {
      this.menuItems.unshift({
        icon: 'custom-map-icon',
        label: new MultiLangStrDto('הצג במפה', 'Location'),
        command: () => this.goToMap(selectedEntity),
        disabled: !selectedEntity.shapes.length
      });
    }
  }

  getMenuItems(currentLang: string) {
    if (!this.menuItems) {
      return [];
    }
    this.languageSpecificMenuItems = this.menuItems.map((module) => {
      return {
        icon: module.icon,
        iconStyle: currentLang === 'en' ? { transform: 'scale(-1, 1)' } : {},
        label: currentLang === 'he' ? (module.label?.hebrew || '') : (module.label?.english || ''),
        command: module.command,
        disabled: module.disabled,
        style: currentLang === 'en' ? { direction: 'ltr' } : {}
      };
    });
    return this.languageSpecificMenuItems;
  }


  setLastFocusedElement(value: any) {
    this.lastFocusedElement = value;
  }

  getLastFocusedElement() {
    return this.lastFocusedElement;
  }

  handleClickEntity(entity: Entity, entityTypes: string[]) {
    this.router.navigate([], {
      queryParams: {
        [TAB_ID]: TabId.TABLE,
        entityTypes,
        licenses: entity.licenses.map((l: any) => l.licenseId).join(","),
      }
    });
  }
openViewer(entity: Entity): void {
  if (entity.entityType === 'dana_pdf' || entity.entityType === 'decision_letter' || entity.entityType === 'decision_letters') {
    const currentLang = this.languageService.currentLanguage.getValue();
    
    this.dialogService.open(PdfViewerDialogComponent, {
      data: {
        url: entity.downloadUrl,
        title: entity.title.hebrew || entity.title.english,
        originEntityId: entity.originEntityId,
        entityType: entity.entityType,
        currentLanguage: currentLang
      },
      header: entity.title.hebrew || entity.title.english,
      width: '90vw',
      height: '90vh',
      styleClass: 'pdf-viewer-dialog',
      maximizable: true,
      modal: true
    });
  } else {
    this.apiService.getBucketImages(entity.originEntityId, entity.entityType).subscribe(images => {
      var archiveThumbnails = images.map(img => ({
        ...img,
        imageId: img.imageId.toString(),
        imageUrl: img.imageUrl
      }));

      this.dialogService.open(ArchiveImageGalleryComponent, {
        data: {
          images: images,
          thumbnails: archiveThumbnails,
          showZoom: true,
          showActivePage: true,
          embedded: true,           // Add this
          disableFullscreen: true,  // And this
          startInDialog: true       // And/or this
        },
        header: entity.title.hebrew,
        width: '80vw',
        height: '80vh',
        styleClass: 'archive-gallery-dialog'
      });
    });
  }
}

  handleClickDetails(entity: Entity): void {
    if (!entity.linkInfo) return;
    const { url, isNewTab, queryParams } = entity.linkInfo;
    this.gaService.trackWithGA(entity.entityType, 'entityType')
    if (entity.entityType === 'orthophoto') {
      this.goToMap(entity);
      return;
    }
    if (entity.entityType === 'photogrammetric_model') {
      this.routingService.navigateToEntity(entity.entityId, entity.entityType);
      return;
    }
    if (entity.entityType==='dana_pdf'){
    }
    if (isNewTab) {
      window.open(url, '_blank');
    } else {
      this.routingService.navigateWithMerge(queryParams, [url || '']);
    }
  }

  async downloadFile(entity:Entity) {
    // the screen blinks with this solution because a word cannot be opened for preview 
    window.open(entity.downloadUrl, '_blank');
    // if we want to prevent that we could use this code instead but the pdf will have a generated id and not the one we set it from header 
    /*
    const url = entity.downloadUrl;
    const response = await fetch(url);
    if (!response.ok) {
      console.error('File download failed');
      return;
    }
  
    const contentType = response.headers.get("Content-Type") || '';
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
  
    const previewableTypes = [
      'application/pdf',
      'image/png',
      'image/jpeg',
      'image/webp',
      'image/gif',
      'text/plain',
      'text/html',
      'audio/mpeg',
      'video/mp4',
    ];
  
    if (previewableTypes.includes(contentType)) {
      window.open(blobUrl, '_blank');
    } else {
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = entity.originEntityId;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    URL.revokeObjectURL(blobUrl);
    */ 

  }
  


  downloadModel(entity: Entity) {
    const link = document.createElement('a');
    if (entity.entityType === 'photogrammetric_model') {
      link.href = entity.downloadUrl;
      link.download = 'model.3mx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  goToMap(rowData: Entity) {
    if (rowData.shapes.length > 0 || rowData.entityType === 'orthophoto') {
      this.routingService.navigateMap(rowData.entityId);
    }
  }
}